var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isInitNearbyInspirations
        ? _c("FilterModal", {
            ref: "filterModal",
            attrs: {
              "city-unique": _vm.cityUnique,
              "filter-modal-type": _vm.filterModalType,
              "nearby-searchbar": _vm.nearbySearchBarData,
            },
            on: {
              "on-filter-button-click": _vm.onFilterButtonClick,
              "on-close-filter": _vm.onCloseFilter,
              "get-filter-search-results": _vm.getFilterSearchResults,
              "show-favorites": _vm.showFavorites,
              "hide-favorites": _vm.hideFavorites,
              "on-badge-update": _vm.badgeUpdated,
              "on-nearby-location-updated": _vm.nearbyLocationUpdated,
              "on-filter-criteria-loaded": _vm.onFilterCriteriaLoaded,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFilterModalTypeHome
        ? [
            _c("Tweakwise", {
              attrs: {
                "city-name": _vm.cityName,
                "city-unique": _vm.cityUnique,
                "city-slug": _vm.citySlug,
                "tag-cloud-data": _vm.tagCloudData,
                "initial-deeplink-response": _vm.initialDeeplinkResponse,
                badge: _vm.badge,
                "show-badge": _vm.showFilterBadge,
                "sort-options": _vm.sortOptions,
                "selected-sort": _vm.currentSortKey,
              },
              on: {
                clear: _vm.handleClear,
                "hide-filter-button": function ($event) {
                  return _vm.handleFilterButtonVisibility(true)
                },
                "show-filter-button": function ($event) {
                  return _vm.handleFilterButtonVisibility(false)
                },
                "show-planning": _vm.showPlanning,
                "hide-planning": _vm.hidePlanningAndFilter,
                "on-focus": _vm.onSearchbarFocus,
                "on-blur": _vm.onSearchbarBlur,
                "on-filter-button-click": _vm.openFilterModal,
                "sort-change": _vm.handleSortChange,
              },
            }),
          ]
        : _vm.isFilterModalTypeNearby
        ? [
            _c("FilterButtons", {
              attrs: {
                badge: _vm.badge,
                "show-badge": _vm.showFilterBadge,
                "filter-type-nearby": true,
                "sort-options": _vm.sortOptions,
                "selected-sort": _vm.currentSortKey,
              },
              on: {
                "on-filter-button-click": _vm.openFilterModal,
                "sort-change": _vm.handleSortChange,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isFilterModalTypeHome
        ? _c(
            "div",
            {
              staticClass: "search-banner-container",
              class: { "has-banner": _vm.shouldShowSearchBanner },
            },
            [
              _c("HotelsSearchBanner", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentCategory === "hotel",
                    expression: "currentCategory === 'hotel'",
                  },
                ],
                attrs: { id: "hotels-banner", "city-slug": _vm.citySlug },
              }),
              _vm._v(" "),
              _c("RestaurantsSearchBanner", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentCategory === "food",
                    expression: "currentCategory === 'food'",
                  },
                ],
                attrs: { id: "restaurants-banner", "city-slug": _vm.citySlug },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.filteredDeals &&
                _vm.filteredDeals.length > 0 &&
                !_vm.isEmptyFilter &&
                _vm.showFilterDeals &&
                !_vm.hideDealsWhenSearchBarIsActive,
              expression:
                "\n      filteredDeals &&\n      filteredDeals.length > 0 &&\n      !isEmptyFilter &&\n      showFilterDeals &&\n      !hideDealsWhenSearchBarIsActive\n    ",
            },
          ],
          staticClass: "filtered-deal-list",
        },
        [
          _c("DealList", {
            attrs: {
              deals: _vm.filteredDeals,
              firstPairDealsAsFeatured:
                !_vm.hideFilterButton &&
                (_vm.isFilterModalTypeHome || _vm.isFilterModalTypeDetails),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isEmptyFilter && _vm.showFilterDeals
        ? _c(
            "div",
            {
              staticClass: "empty-filter",
              class: {
                "nearby-filter-empty-filter-padding":
                  _vm.isFilterModalTypeNearby,
              },
            },
            [
              _c("Message", {
                attrs: {
                  "image-src": "/img/no-deals-found.svg",
                  label: _vm.$t("36079.App_FilterHomeEmptyStateCaption"),
                },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "favorite-empty-state-button",
                  on: { click: _vm.resetFilterOutsideModal },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("36080.App_FilterHomeEmptyStateButton"))
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.experiences &&
              _vm.experiences.experiences.length > 0 &&
              _vm.isFilterModalTypeHome
                ? _c("ExperienceList", {
                    staticClass: "filter-experiences",
                    attrs: { experiences: _vm.experiences },
                    on: { click: _vm.handleExperienceItemClick },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }